enum RpcMethod {
  CREATE = 'create',
  PASSWORD_RESET_REQUEST = 'password-reset-request',
  PASSWORD_RESET = 'reset-password',
  UNSUBSCRIBE = 'unsubscribe',
  MIGRATE_PLAN = 'migratePlan',
  GET_PRICES = 'getPrices',
  USERNAME_AVAILABLE = 'username-available',
  GET_BY_ORGANIZATION = 'get-by-organization',
  GET_BY_MEMBER = 'get-by-member',
  DOWNGRADE = 'downgradeToFree',
  REQUEST_EMAIL_VERIFICATION = 'request-verification-email',
  GET_SUBSCRIPTION_DETAILS = 'getSubscriptionDetails',
  GET_SUBSCRIPTION_PREVIEW = 'getSubscriptionPreview',
  GET_BILLING_DETAILS = 'getBillingDetails',
  UPDATE_BILLING_ADDRESS = 'updateBillingAddress',
  GET_STATEMENTS = 'get-statements',
  SET_CREDIT_CARD_WITH_TOKEN = 'set-credit-card-with-token',
  SET_CREDIT_CARD_WITH_PAYMENT_METHOD = 'setCreditCardWithPaymentMethod',
  CREATE_SETUP_INTENT = 'createSetupIntent',
  GET_PDF_STATEMENT = 'get-pdf-statement',
  CANCEL_ANNUAL_SUBSCRIPTION = 'cancelAnnualSubscription',
  GET_PDF_INVOICE = 'getPdfInvoice',
  VERIFY_EMAIL = 'verifyEmail',
  INVITE_MEMBER = 'invite-member',
  WEEKLY_EMAIL_UNSUBSCRIBE = 'weeklyEmailUnsubscribe',
  COUPLE_DEVICE = 'couple',
  UNCOUPLE_DEVICE = 'uncouple',
  CLEAR_CUSTOM_FIELD_VALUES = 'clearCustomFieldValues',
  UPDATE_START_DATE = 'updateStartDate',
  DELETE = 'delete',
  DUPLICATE = 'duplicate',
  REORDER = 'reorder',
  REORDER_RELATIVE = 'reorderRelative',
  RESET_SCHEDULED_TASKS = 'resetScheduledTasks',
  RESET_SCHEDULED_TASK = 'resetScheduledTask',
  RESUBMIT_SCHEDULED_TASKS = 'resubmitScheduledTasks',
  RESUBMIT_SCHEDULED_TASK = 'resubmitScheduledTask',
  UPDATE_SCHEDULED_TASKS_DATE = 'updateScheduledTasksDate',
  UPDATE_SCHEDULED_TASK_DATE = 'updateScheduledTaskDate',
  DELETE_OUT_OF_RANGE_REMINDERS = 'deleteOutOfRangeReminders',
  EXTEND_IN_RANGE_REMINDERS = 'extendInRangeReminders',
  RESET_SCHEDULED_SAFETY_EVENT_TASKS = 'resetScheduledSafetyEventTasks',
  RESUBMIT_SCHEDULED_SAFETY_EVENT_TASKS = 'resubmitScheduledSafetyEventTasks',
  UPDATE_SCHEDULED_SAFETY_EVENT_TASKS_DATE = 'updateScheduledSafetyEventTasksDate',
  UPDATE_SAFETY_EVENT_TASKS_DATE = 'updateSafetyEventTasksDate',
}

export default RpcMethod;
